module.exports = __webpack_public_path__ + "media/images/icons/group-5e5ceebb4a45a02fff6a827786301070.svg";